module.exports = __webpack_public_path__ + "static/media/mantenimiento.fced3a43.jpg";